/* eslint-disable react/prop-types */
import { EmailAddress } from '@constants';

export default function SeelEmail({ style = {}, text = `${EmailAddress.Seel}`, email = EmailAddress.Seel }) {
  return (
    <a
      href={`mailto:${email}`}
      style={{
        color: '#645AFF',
        ...style,
      }}
    >
      {text}
    </a>
  );
}
